import Layout from "components/layout/Layout"
import { Link } from "react-router-dom";
import ContactForm from "components/contact/ContactForm";

const Contact = () => {
  return (
      <Layout headerStyle={1} footerStyle={1} breadcrumbTitle={<> Contact <span>Us</span> </>}>
        <div>
          <section className="contact-area pb-140">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="contact-form-wrap">
                    <div className="row">
                      <div className="col-md-12 col-lg-10 mx-auto">
                        <div className="contact-form">
                          <ContactForm />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-12 col-lg-9 mx-auto">
                  <div className="help-center-wrap contact-form-wrap">
                    <h2 className="title mt-5">
                      If you have any questions,<span> contact us</span>
                    </h2>
                    <div className="row">
                      <div className="col-12">
                        <div className="help-center-item">
                          <div className="icon">
                            <img src="assets/img/icon/help_icon02.svg" alt="" />
                          </div>
                          <div className="content">
                            <Link to="mailto:support@bodylytix.ai">
                              support@bodylytix.ai
                            </Link>
                            <p>The best way to get answer faster.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </Layout>
  )
}

export default Contact
